module.exports = __webpack_public_path__ + "static/media/demo.2124f828.jpg";